/**
 * External dependencies
 */
import { get } from "lodash";
import { getPreference } from "state/preferences/selectors";
import moment from "moment";

export const getDateRange = (state) => get(state, ["ui", "dateRange", "date"]);
export const getStartDate = (state) =>
  get(state, ["ui", "dateRange", "startDate"]);
export const getEndDate = (state) => get(state, ["ui", "dateRange", "endDate"]);

export const getFormattedDateRange = (state) => {
  return [getStartDate(state), getEndDate(state)];
};

export const getCompareDateRange = (state) =>
  get(state, ["ui", "dateRange", "compareDate"]) ||
  getPreference(state, "compareDateRange");

export const getCompareType = (state) =>
  get(state, ["ui", "dateRange", "compareType"]) || "previous";

export const formatDateString = (state) => {
  const startDate = moment(getStartDate(state), "YYYY-MM-DD:HH:mm:ss");
  const endDate = moment(getEndDate(state));

  return `${startDate.format("MMM D")} - ${endDate.format("MMM D, YYYY")}`;
};

export const formatCompareString = (state) => {
  const dates = getCompareDateRange(state);
  if (!dates) return "No comparison date range";
  const startDate = moment(dates[0]);
  const endDate = moment(dates[1]);
  return `${startDate.format("MMM D")} - ${endDate.format("MMM D, YYYY")}`;
};
